module.exports = __webpack_public_path__ + "static/media/icon_roubo.d3370542.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_roubo.svg
// module id = 525
// module chunks = 0